/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Balancing_Display_HslopeInputs */



/**
* | output |
* | --- |
* | "Speed" |
*
* @param {Manual_Balancing_Display_HslopeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const manual_balancing_display_hslope = /** @type {((inputs?: Manual_Balancing_Display_HslopeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Balancing_Display_HslopeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Speed")
	return /** @type {LocalizedString} */ ("Vitesse")
});